import { render, staticRenderFns } from "./AppExhibitionDate.vue?vue&type=template&id=26810956&scoped=true"
import script from "./AppExhibitionDate.vue?vue&type=script&lang=js"
export * from "./AppExhibitionDate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26810956",
  null
  
)

export default component.exports